/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData,
  UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSON,
  UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSONTyped,
  UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataToJSON
} from './UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData'

/**
 *
 * @export
 * @interface UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response
 */
export interface UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response {
  /**
   *
   * @type {number}
   * @memberof UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response
   */
  status: number
  /**
   *
   * @type {UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData}
   * @memberof UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response
   */
  data: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData
}

export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseFromJSON(
  json: any
): UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response {
  return UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseFromJSONTyped(
    json,
    false
  )
}

export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSON(
      json['data']
    )
  }
}

export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseToJSON(
  value?: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200Response | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataToJSON(value.data)
  }
}
